module.exports = __webpack_public_path__ + "asset/image/ic_unionpay-b6e2.svg";